// @flow @format
import Header from './containers/HeaderContainer';
import FilesLayout from './layouts/FilesLayout';
import Footer from './components/Footer';
import FileExplorerContainer from './containers/FileExplorerContainer';
import RepositoryExplorerContainer from './containers/RepositoryExplorerContainer';
import withRouteSelection from './hoc/withRouteSelection';

import type {Store} from 'redux';
import type {State} from '../../reducers';

const routes = (store: Store<*, *>) => ({
	path: 'explorer',
	onEnter: (nextState: Object, replace: (path: string) => void) => {
		const state: State = store.getState();

		if (!state.session.isLoggedIn) {
			return replace('/login');
		}
	},
	components: {
		header: Header,
		main: FilesLayout,
		footer: Footer,
	},
	indexRoute: {
		component: withRouteSelection(RepositoryExplorerContainer),
	},
	childRoutes: [
		{
			path: '/explorer/files/:repositoryId/:fileId',
			component: withRouteSelection(FileExplorerContainer),
		},
	],
});

export default routes;



// WEBPACK FOOTER //
// ./src/routes/Explorer/index.js